/* eslint-disable @typescript-eslint/no-unused-expressions */
// As part of my eslint upgrade, these were flagged as suspicious. I'm not entirely sure what to do, so I have ignored them for now.
export const combineHandlerWithFormik = (formikHandler, customHandler) => e => {
  formikHandler && typeof formikHandler === 'function' && formikHandler(e);
  customHandler && typeof customHandler === 'function' && customHandler(e);
};